import { Vector2 } from "three";
import { ChangeEvent } from "../../events/ChangeEvent";
import { ComparableProperty } from "../../events/ComparableProperty";
import { EventSlot } from "../../events/EventSlot";
import { Margins } from "./Margins";

export class Dimensions
{
  readonly position = new ComparableProperty<Vector2>( new Vector2( 0, 0 ) );
  readonly size     = new ComparableProperty<Vector2>( new Vector2( 1, 1 ) );
  
  readonly onChange = new EventSlot<Dimensions>();

  constructor()
  {
    this.position.addListener( () => { this.onChange.dispatch( this ); } );
    this.size.addListener( () => { this.onChange.dispatch( this ); } );
  }

  get x(){ return this.position.value.x; }
  get y(){ return this.position.value.y; }

  set x( value:number ){ this.position.value.x = value; this.position.forceDispatch(); }
  set y( value:number ){ this.position.value.y = value; this.position.forceDispatch(); }

  get width(){ return this.size.value.x; }
  get height(){ return this.size.value.y; }

  set width( value:number ){ this.size.value.x = value; this.size.forceDispatch(); }
  set height( value:number ){ this.size.value.y = value; this.size.forceDispatch(); }

  set( x:number, y:number, width:number, height:number, forceDispatch:boolean = false )
  {
    this.position.value.set( x, y );
    this.size.value.set( width, height ); 

    if ( forceDispatch )
    {
      this.position.forceDispatch();
      this.size.forceDispatch();
    }

    this.onChange.dispatch( this );
  }

  setWith( x:number, y:number, width:number, height:number, margins:Margins = undefined )
  {
    margins = margins || Margins.NoMargins;
    
    this.set( 
      x + margins.left, y + margins.top, 
      width - margins.horizontalSum, height - margins.verticalSum 
    );
  }


  setFrom( dimensions:Dimensions )
  {
    this.set( dimensions.x, dimensions.y, dimensions.width, dimensions.height );
  }

  link( ...dimensions:Dimensions[] )
  {
    this.onChange.addListener(
      ()=>
      {
        let x = this.x;
        let y = this.y;
        let w = this.width;
        let h = this.height;

        dimensions.forEach( d => { d.set( x, y, w, h ) } );
      }
    )
  }

  applyTo( element:HTMLElement, margins?:Margins )
  { 
    margins = margins || Margins.NoMargins;
    
    element.style.left   = ( this.x + margins.left ) + "px";
    element.style.top    = ( this.y + margins.top ) + "px";
    element.style.width  = ( this.width - margins.horizontalSum ) + "px";
    element.style.height = ( this.height - margins.verticalSum ) + "px";
  }
}